import React, { useEffect, useState } from "react";
import Fields from "./Fields";
import { useNavigate, useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { createYupSchema } from "../../utilities/yupSchemaCreator";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import {
  Alert,
  Box,
  Button,
  Card,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import styled from "styled-components";
import ErrorsList from "../../ui/ErrorsList";
import { useExpenses } from "./provider";
import { useOdooInvoices } from "../OdooInvoices/provider";
import RestrictedCell from './Render/RestrictedCell';
const yupSchema = Fields.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);

const GridGroup = styled.div`
  max-width: 1210px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  row-gap: 0;
  padding: 20px;
  margin-bottom: 20px;
  grid-template-rows: 80px;
`;

const ButtonWrapper = styled.div`
  margin-bottom: 50px;
  button {
    float: right;
    margin-left: 20px;
  }
`;
const FormExpenses = ({ expense, handleSuccess }) => {
  let navigate = useNavigate();
  const { id } = useParams();
  let theme = useTheme();
  const [error, setError] = useState(null);
  const { create, edit } = useExpenses();
  const {
    state: { listOdooNames },
    fetchOdooAccountsNamesList,
  } = useOdooInvoices();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: expense,
  });

  useEffect(() => {
    fetchOdooAccountsNamesList();
  }, []);
  const onSubmit = async (values) => {
    try {
      if (expense) {
        await edit(values, id);
      } else {
        await create(values);
      }
      handleSuccess();
    } catch (error) {
      setError({ title: error?.errors?.message?.toString() });
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Card
        sx={{
          p: theme.dimensions.padding,
          mt: theme.dimensions.mt,
          mb: theme.dimensions.mb,
        }}
      >
        <Typography variant="Poster" mb={3} component="h4" gutterBottom>
          Expense Details
        </Typography>
        {error ? (
          <Alert severity="error" sx={{ m: 3 }}>
            <ErrorsList error={error} />
          </Alert>
        ) : (
          ""
        )}
        <GridGroup>
          {Fields?.map((f, i) => {
            if (f.viewOnly) return null;
            const inputProps = { ...f.inputProps };

            if (i === 0) inputProps.autoFocus = true;
            inputProps.type = f.type;
            return (
              <Box key={i}>
                {f.switch ? (
                  <Box>
                    {f.name === "isActive" && (
                      <FormGroup>
                        <FormLabel
                          component="legend"
                          sx={{
                            mt: theme.dimensions.mt,
                          }}
                        >
                          {f.label}
                        </FormLabel>
                        <FormControlLabel
                          sx={{
                            mt: theme.dimensions.mt,
                          }}
                          control={
                            <Switch
                              color="success"
                              defaultChecked={
                                expense ? expense?.isActive : true
                              }
                            />
                          }
                          {...register(f?.name)}
                          label="Active"
                        />
                      </FormGroup>
                    )}
                    {f.name === "restricted" && (
                      <FormGroup>
                        <FormLabel
                          component="legend"
                          sx={{
                            mt: theme.dimensions.mt,
                          }}
                        >
                          {f.label}
                        </FormLabel>
                        <FormControlLabel
                          sx={{
                            mt: theme.dimensions.mt,
                          }}
                          control={
                            <Switch
                              color="success"
                              defaultChecked={
                                expense ? expense?.restricted : true
                              }
                            />
                          }
                          {...register(f?.name)}
                          label="Restricted"
                        />
                      </FormGroup>
                    )}
                  </Box>
                ) : f.select ? (
                  <FormControl
                    sx={{
                      width: theme.dimensions.width,
                      mt: theme.dimensions.mt,
                      mb: theme.dimensions.mb,
                    }}
                    required
                    error={!!errors[f.name]}
                  >
                    <InputLabel id="demo-simple-select-label">
                      {f.label}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      /*     defaultValue={account?.typeId} */
                      label={f.label}
                      inputProps={{
                        ...register(f?.name),
                        required: true,
                      }}
                      size="small"
                      defaultValue={expense?.accountId}
                    >
                      {listOdooNames?.map((s, index) => (
                        <MenuItem key={index} value={s.id}>
                          {s.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : (
                  <>
                    <TextField
                      label={f.label}
                      name={f.name}
                      error={!!errors[f.name]}
                      helperText={errors[f.name]?.message}
                      select={f.select}
                      className={f.class}
                      fullWidth
                      required
                      disabled={f.disabled}
                      sx={{
                        width: theme.dimensions.width,
                        mt: theme.dimensions.mt,
                        mb: theme.dimensions.mb,
                      }}
                      inputProps={{
                        ...register(f?.name),
                        required: f.required,
                      }}
                      size="small"
                    ></TextField>
                  </>
                )}
              </Box>
            );
          })}
        </GridGroup>
        <ButtonWrapper>
          <Button
            variant="contained"
            type="submit"
            sx={{
              backgroundColor: theme.color.blackBackground,
              ml: theme.dimensions.ml,
              "&:hover": { background: `${theme.color.black}` },
            }}
          >
            {expense ? <>Update</> : <>Add Expense</>}
          </Button>
          <Button
            variant="contained"
            onClick={() => navigate(-1)}
            sx={{
              backgroundColor: theme.color.grayBackground,
              color: theme.color.dark,
              "&:hover": { background: `${theme.color.gray50}` },
            }}
          >
            Discard
          </Button>
        </ButtonWrapper>
      </Card>
    </form>
  );
};

export default FormExpenses;
